import core from "@subly/s1/core";

export default {
	...core
};